import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    shareholder: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    capital: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    common: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    pref: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    total: {
        width: '15%'
    },
    owned: {
        width: '15%'
    },
  });

  const CapTableTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.shareholder}>Shareholder</Text>
        <Text style={styles.capital}>Capital($)</Text>
        <Text style={styles.common}>Common Shares</Text>
        <Text style={styles.pref}>Pref. Shares</Text>
        <Text style={styles.total}>Total Shares</Text>
        <Text style={styles.owned}>% Owned</Text>
    </View>
  );
  
  export default CapTableTableHeader